class fullChartHours {
    constructor(options) {
        const defaultTimes = [
            '08:00', '09:00', '10:00', '11:00', '12:00',
            '13:00', '14:00', '15:00', '16:00',
            '17:00', '18:00', '19:00'
        ];
        
        const sliceIndexFrom = defaultTimes.indexOf(options.timeFrom);
        const sliceIndexTo = defaultTimes.indexOf(options.timeTo);
        this.matchedTimes = defaultTimes.slice(sliceIndexFrom, sliceIndexTo);
        this.labels = null;
        this.prepare();
    }

    prepare() {
        const data = [];

        this.matchedTimes.forEach(item => {
            const value = parseInt(item.split(':')[0]);
            const nextValue = value + 1;

            data.push(`${value}:${nextValue}`);
        });

        this.labels = data;
    }
}

export default fullChartHours;